import { render, staticRenderFns } from "./ProductItemRow.vue?vue&type=template&id=d741d71e&scoped=true&"
import script from "./ProductItemRow.vue?vue&type=script&lang=js&"
export * from "./ProductItemRow.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemRow.vue?vue&type=style&index=0&id=d741d71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d741d71e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VCol,VImg,VRow,VTextField})
